import * as effects from 'redux-saga/effects';
import { api } from '@REST/api';
import { handleError } from '@bus/ui/saga/workers/handleError';
import { throwError } from '@bus/ui/saga/workers/throwError';

import { storyTellerActions } from '../../actions';
import { FillStoryActionPayload } from '../../typedefs';
import { PayloadActionWithPromiseMeta } from '@core/FinalForm/typedefs';
import { processSvg } from '@helpers/processSvg';

export function* fetchStory({
  meta: { resolve, reject },
}: PayloadActionWithPromiseMeta<any>) {
  try {
    yield effects.put(storyTellerActions.startFetching());
    const response: Response = yield effects.apply(api, api.get, [
      { endpoint: 'storytellers/projects/' },
    ]);
    if (!response.ok) {
      reject();
      yield throwError(response);
    }

    const data: FillStoryActionPayload = yield effects.call([response, 'json']);

    const fetchedStories: FillStoryActionPayload = yield effects.all(
      data.map(function* (project) {
        const svgContent: string = yield effects.call(processSvg, project.icon);

        return { ...project, icon: svgContent };
      }),
    );

    yield effects.put(storyTellerActions.fillStory(fetchedStories));
    resolve();
  } catch (e) {
    yield handleError(e);
  } finally {
    yield effects.put(storyTellerActions.stopFetching());
  }
}
